var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEndicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49998 14.25C7.32474 14.2503 7.15491 14.1893 7.01998 14.0775C6.8666 13.9503 6.77012 13.7673 6.75183 13.5689C6.73354 13.3705 6.79494 13.173 6.92248 13.02L10.2825 8.99996L7.04248 4.97246C6.91665 4.81751 6.85778 4.6188 6.87889 4.42032C6.90001 4.22184 6.99937 4.03996 7.15498 3.91496C7.31185 3.77693 7.5192 3.7106 7.72706 3.73196C7.93492 3.75331 8.12445 3.86041 8.24998 4.02746L11.8725 8.52746C12.1 8.80421 12.1 9.20321 11.8725 9.47996L8.12248 13.98C7.96988 14.164 7.73866 14.2643 7.49998 14.25Z",
    fill: "#1C252E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndicon);
export default __webpack_public_path__ + "static/media/end icon.08780bd601f9a9931ce1993524caf6f9.svg";
export { ForwardRef as ReactComponent };